import * as yup from 'yup';

import { AddressFieldsFormFields } from 'src/constants/address';
import {
  ERROR_MESSAGE_REQUIRED_ZIP_CODE,
  emailValidationSchema,
  numberOfEmployeesSimpleValidationSchema,
  phoneNumberValidationSchema,
  taxYearEndDateSimpleValidationSchema,
  zipCodeValidationSchema,
} from 'src/constants/validation';

import { EmployerCompanyInformationFormFields } from '../types';

export const EmployerCompanyInformationFormValidationSchema = yup.object({
  [EmployerCompanyInformationFormFields.displayName]: yup
    .string()
    .nullable()
    .required('Required company display name'),
  [EmployerCompanyInformationFormFields.industry]: yup.object({ value: yup.string() }).nullable(),
  [EmployerCompanyInformationFormFields.taxYearEndDate]: taxYearEndDateSimpleValidationSchema,
  [EmployerCompanyInformationFormFields.numberOfEmployees]: numberOfEmployeesSimpleValidationSchema,
  [EmployerCompanyInformationFormFields.corporateStructure]: yup.string().nullable(),
  [EmployerCompanyInformationFormFields.contactPhoneNumber]: phoneNumberValidationSchema,
  [EmployerCompanyInformationFormFields.contactEmail]:
    emailValidationSchema.required('Required contact email'),
  [EmployerCompanyInformationFormFields.disclaimer]: yup.string().nullable(),
  [EmployerCompanyInformationFormFields.headquarters]: yup.object({
    [AddressFieldsFormFields.street]: yup.string().required('Required street'),
    [AddressFieldsFormFields.city]: yup.string().required('Required city'),
    [AddressFieldsFormFields.county]: yup.string().nullable(),
    [AddressFieldsFormFields.state]: yup.string().required('Required state'),
    [AddressFieldsFormFields.zipCode]: zipCodeValidationSchema.required(
      ERROR_MESSAGE_REQUIRED_ZIP_CODE,
    ),
  }),
});
